import React, { Component }  from 'react';
import '../../style.css';
import {Button, Card, Form, Modal, Space, Table, Input, message, PageHeader,Select} from "antd";
import { DeleteOutlined, EditOutlined,} from "@ant-design/icons";
import {fetchPost} from "../../static/util/fetch";
const { Column } = Table;
const Option = Select.Option;

class HighTechList extends Component {
    constructor(props){
        super(props);
        this.state={
            loading:false,
            product:[],//高品列表
            companyNames:[],//公司名称列表
            companyId:0,
            addCompanyId:0,
            companyName:'请选择公司',//查找时选中的公司名称
            addCompanyName:'请选择公司',//添加时选中的公司名称
            add_visible:false,//添加弹窗开关
            edit_visible:false,//编辑弹窗开关
            delete_visible:false,//删除弹窗开关
            productName:'',
            newProductName:'',
            editId:'',
            deleteId:'',
            deleteProductName:'',
        }
        this.hideModal = this.hideModal.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
        this.handleAddClick = this.handleAddClick.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.addProduct = this.addProduct.bind(this);
        this.uploadProduct = this.uploadProduct.bind(this);
        this.deleteProduct = this.deleteProduct.bind(this);
        this.getProductList = this.getProductList.bind(this);
        this.productNameChange = this.productNameChange.bind(this);
        this.productNameChangeNew = this.productNameChangeNew.bind(this);
    }
    componentDidMount() {
        //获取登录用户的所有产品
        // this.setState(()=>({
        //     loading:true
        // }))
        // fetchPost(global.constants.getAllProduct,{})
        //     .then(
        //         res => {
        //             if(res.code === 200) {
        //                 this.setState(()=>({
        //                     product:res.data,
        //                     loading:false
        //                 }))
        //             }
        //             else{
        //                 this.setState(()=>({
        //                     loading:false
        //                 }))
        //                message.info(res.msg).then()
        //             }
        //         }
        //     )
        //获取用户全部公司名称
        fetchPost(global.constants.getCompanyNameList,{})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            companyNames:res.data,
                        }))
                        console.log(this.state.companyNames)
                    }
                    else{
                        message.info(res.msg).then()
                    }
                }
            )
    }
    chooseAddCompany(value){
        this.setState(()=>({
            addCompanyName:value
        }))
    }
    getProductList = (e) => {
        const value = e
        this.setState(()=>({
            companyName:value,
            addCompanyName:value,
            loading:true
        }))
        if(value === '全部产品'){
            fetchPost(global.constants.getAllProduct,{})
                .then(
                    res => {
                        if(res.code === 200) {
                            this.setState(()=>({
                                product:res.data,
                                loading:false
                            }))
                        }else {
                            this.setState(() => ({
                                product: [],
                                loading:false
                            }))
                            message.info("该用户未添加高新产品").then()
                        }
                    }
                )
        }else{
            // for(let i = 0;i < this.state.companyNames.length; i++ ){
            //     if(this.state.companyNames[i].companyName === value){
            //
            //     }
            // }
            this.state.companyNames.find((obj) => {
                if(obj.companyName === value){
                    this.setState(() => ({
                        companyId: obj.id
                    }))
                    fetchPost(global.constants.getCompanyProductList, {companyId:obj.id })
                        .then(
                            res => {
                                if (res.code === 200) {
                                    this.setState(() => ({
                                        product: res.data,
                                        loading:false
                                    }))
                                }
                                else{
                                    message.info("该公司未添加高新产品").then()
                                    this.setState(()=>({
                                        product:null,
                                        loading:false
                                    }))
                                }
                            }
                        )
                }
            })
        }

    }
    hideModal(){
        //关闭弹窗
        this.setState(()=>({
            add_visible:false,
            edit_visible:false,
            delete_visible:false,
        }))
    }
    handleEditClick= (e) =>{
        const value = e.id;
        //打开编辑弹窗
        this.setState(()=>({
            editId:value,
        }))
        fetchPost(global.constants.getProduct,{id:value})
            .then(
                res =>{
                    console.log(res)
                    if(res.code === 200){
                        this.setState(()=>({
                            newProductName: res.data.productName,
                            edit_visible:true,
                        }))
                    }
                }
            )
    }
    uploadProduct(){
        let params = {
            id:this.state.editId,
            productName:this.state.newProductName,
        }
        fetchPost(global.constants.alterProduct,params)
            .then(
                res => {
                    if(res.code === 200) {
                        message.success(res.msg).then()
                        this.setState(() => ({
                            edit_visible: false
                        }))
                        if (this.state.companyName === '全部产品') {
                            fetchPost(global.constants.getAllProduct, {})
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            this.setState(() => ({
                                                product: res.data,
                                                loading: false
                                            }))
                                        } else {
                                            this.setState(() => ({
                                                product: [],
                                                loading: false
                                            }))
                                            message.info("该用户未添加高新产品").then()
                                        }
                                    }
                                )
                        } else {
                            fetchPost(global.constants.getCompanyProductList, {companyId: this.state.companyId})
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            this.setState(() => ({
                                                product: res.data,
                                            }))
                                        } else {
                                            message.info("该公司没有产品").then()
                                            this.setState(() => ({
                                                product: []
                                            }))
                                        }
                                    }
                                )//更新后重新请求
                        }
                    }
                    else {
                        message.info("修改失败").then()
                    }
                }
            )
    }
    handleDeleteClick=(e)=>{
        const value_id = e.id;
        const value_productName = e.productName;
        this.setState(()=>({
            delete_visible:true,
            deleteId:value_id,
            deleteProductName:value_productName,
        }))
    }
    deleteProduct(){
        let params = {
            id:this.state.deleteId,
        }
        fetchPost(global.constants.deleteProduct,params)
            .then(
                res => {
                    if(res.code === 200){
                        message.success('删除产品成功').then()
                        this.setState(()=>({
                            delete_visible:false
                        }))
                        if(this.state.companyName === '全部产品'){
                            fetchPost(global.constants.getAllProduct,{})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                product:res.data,
                                                loading:false
                                            }))
                                        }else {
                                            this.setState(() => ({
                                                product: [],
                                                loading:false
                                            }))
                                            message.info("该用户未添加高新产品").then()
                                        }
                                    }
                                )
                        }else{
                            fetchPost(global.constants.getCompanyProductList, {companyId: this.state.companyId})
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            this.setState(() => ({
                                                product: res.data,
                                            }))
                                        }
                                        else{
                                            message.info("该公司没有产品").then()
                                            this.setState(()=>({
                                                product:[]
                                            }))
                                        }
                                    }
                                )//更新后重新请求
                        }
                    }
                    else{
                        message.error("删除失败").then()
                    }
                }
            )
    }
    checkProduct(){
        fetchPost(global.constants.checkProductName,{productName:this.state.productName})
            .then(
                res=>{
                    if(res.code === -1){
                        alert("该产品已存在")
                    }
                }
            )
    }
    addProduct(){
        if(this.state.addCompanyName === '请选择公司'){
            message.info('请选择产品所属的公司').then()
        }else{
            // fetchPost(global.constants.checkProductName,{productName:this.state.productName})
            //     .then(
            //         res=>{
            //             if(res.code === -1){
            //                 alert("该产品已存在")
            //             }
            //             else{})
            this.state.companyNames.find((obj) => {
                if (obj.companyName === this.state.addCompanyName) {
                    this.setState(() => ({
                        addCompanyId: obj.id
                    }))
                    let params = {
                        companyId: obj.id,
                        productName: this.state.productName,
                    }
                    if (this.state.addCompanyName === '请选择公司') {
                        message.error("请先选择公司再添加产品").then()
                    } else {
                        if (this.state.productName === '') {
                            message.error('产品名称不能为空').then()
                        } else {
                            fetchPost(global.constants.addProduct, params)
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            message.success('添加成功').then()
                                            this.setState(() => ({
                                                add_visible: false
                                            }))
                                            //重新获取列表
                                            if (this.state.addCompanyName === '请选择公司') {
                                                this.setState(() => ({
                                                    companyName: this.state.addCompanyName
                                                }))
                                                fetchPost(global.constants.getAllProduct, {})
                                                    .then(
                                                        res => {
                                                            if (res.code === 200) {
                                                                this.setState(() => ({
                                                                    product: res.data,
                                                                }))
                                                            } else {
                                                                this.setState(() => ({
                                                                    product: []
                                                                }))
                                                            }
                                                        }
                                                    )
                                            } else {
                                                this.setState(() => ({
                                                    companyName: this.state.addCompanyName,
                                                    companyId:this.state.addCompanyId
                                                }))
                                                fetchPost(global.constants.getCompanyProductList, {companyId: this.state.companyId})
                                                    .then(
                                                        res => {
                                                            if (res.code === 200) {
                                                                this.setState(() => ({
                                                                    product: res.data,
                                                                }))
                                                            } else {
                                                                this.setState(() => ({
                                                                    product: []
                                                                }))
                                                            }
                                                        }
                                                    )
                                            }//更新后重新请求
                                        } else {
                                            message.error("添加失败").then()
                                            // if (res.code === -1) {
                                            //     console.log("添加产品失败，该产品已经存在！")
                                            // }
                                            // if (res.code === -2) {
                                            //     console.log("添加产品失败（数据库错误）！")
                                            // }
                                            // if (res.code === -3) {
                                            //     console.log("该公司已经绑定此产品！")
                                            // }
                                            // if (res.code === -4) {
                                            //     console.log("添加产品失败（数据库错误）！")
                                            // }
                                            // if (res.code === null) {
                                            //     console.log("返回值为空，添加失败")
                                            // }
                                        }
                                    }
                                )
                        }
                    }
                }
            })
        }
    }
    handleAddClick(){
        //打开添加高品弹窗
        this.setState(()=>({
            add_visible:true,
            addCompanyName:'请选择公司',
        }))
    }
    render() {
        return(
            <div className="content-frame">
                <div className="content-form">
                    <div className="content-page-header">
                        <PageHeader
                            ghost={false}
                            title="高新产品列表"
                            subTitle={"请选择公司查找高新产品"}
                            extra={[
                                <Button
                                    type="primary"
                                    onClick={this.handleAddClick}
                                >
                                    添加高新产品
                                </Button>
                            ]}
                        >
                        </PageHeader>
                    </div>
                <Space direction="vertical" className="content-style" >
                    <div>
                        <Select showSearch
                                style={{ width: 300 }}
                                placeholder="请选择公司"
                                optionFilterProp="children"
                                notFoundContent="无法找到"
                                searchPlaceholder="输入关键词"
                                onChange={this.getProductList.bind(this)}
                                value={this.state.companyName}
                                defaultValue={this.state.companyName}
                        >
                            {/*<Option key="全部产品" value="全部产品">*/}
                            {/*   全部产品*/}
                            {/*</Option>*/}
                            {
                                this.state.companyNames.map(item => (
                                <Option key={item.companyName} value={item.companyName}>
                                    {item.companyName}
                                </Option>
                            ))}
                        </Select>
                            {/*<Tag color="geekblue" className="Tag_style">{this.state.companyName}</Tag>*/}
                    </div>
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.product} loading={this.state.loading}>
                            <Column align="center" title={<p className="list-column-style">序号</p>} width="80" render={(text,record,index)=>`${index+1}`}/>
                            <Column align="center" title={<p className="list-column-style">高新产品名称</p>} dataIndex="productName" key="productName" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">操作</p>}
                                key="action"
                                render={(text, record) => (
                                    <Space size="middle">
                                        <Button
                                            type="primary"
                                            icon={<EditOutlined />}
                                            onClick={this.handleEditClick.bind(this,record)}
                                        >编辑</Button>
                                        <Button
                                            type="primary"
                                            icon={<DeleteOutlined />}
                                            onClick={this.handleDeleteClick.bind(this,record)}
                                        >删除</Button>
                                    </Space>
                                )}
                            />
                        </Table>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.edit_visible}
                    title={'高新技术产品'}
                    onOk={this.uploadProduct}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.uploadProduct}>
                            提交
                        </Button>,
                    ]}
                >
                    <Form>
                        <Form.Item label="名称" name="newProductName" >
                            <Input defaultValue={this.state.newProductName} onChange={(e) => this.productNameChangeNew(e.target.value)}/></Form.Item>
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.add_visible}
                    title={'添加高新产品'}
                    onOk={this.addProduct}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.addProduct}>
                            提交
                        </Button>,
                    ]}
                >
                    <Form>
                        <Form.Item  name="addCompanyName" rules={[{ required: false, message: '请选择公司!' }]}>
                            <Select showSearch
                                    allowClear
                                    style={{ width: 300 }}
                                    placeholder="请选择公司"
                                    optionFilterProp="children"
                                    notFoundContent="无法找到"
                                    searchPlaceholder="输入关键词"
                                    onChange={this.chooseAddCompany.bind(this)}
                                    >
                                {this.state.companyNames.map(item => (
                                    <Option key={item.companyName} value={item.companyName}>
                                        {item.companyName}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="产品名称" name="productName" rules={[{ required: true, message: '请输入产品名称!' }]}>
                            <Input
                                onChange={(e) => this.productNameChange(e.target.value)}
                                // onBlur={this.checkProduct.bind(this)}
                            /></Form.Item>
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.delete_visible}
                    title={'温馨提示'}
                    onOk={this.deleteProduct}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.deleteProduct}>
                            确定
                        </Button>,
                    ]}
                >
                    <div>确定删除该产品吗？</div>
                </Modal>
            </div>
            </div>
        )
    }
    productNameChange(e){
        this.setState(()=>({
            productName:e
        }))
    }
    productNameChangeNew(e){
        this.setState(()=>({
            newProductName:e
        }))
    }
}
export default HighTechList;